module.exports = __webpack_public_path__ + "img/house.69ac4e00.png";